import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { triggerShowBrokenLinkDialog } from '../Services/BrokenLinkDialogHelper.tsx';

interface ErrorResponse {
  message: string;
}

const axiosInstance = axios.create({
  headers: { 'Content-Type': 'application/json; charset=utf-8' },
});

// inject token on every request
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {

    const token = localStorage.getItem('lbmc_token');

    if (token) {
      config.headers = config.headers ?? {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError<ErrorResponse>) => {
    if (error.response) {
      const { status, data } : any = error.response;
      if (status === 401) {
        console.error('Unauthorized, redirecting to login.');
      } else if (status === 500 && data == "Invalid Guid") {
        triggerShowBrokenLinkDialog();
      } else {
        console.error(`Error ${status}:`, data.message);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;